(function () {
    'use strict';

    angular
        .module('portalApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', '$localStorage', 'Translation',
        'amMoment'];

    function translationHandler($rootScope, $window, $state, $translate, $localStorage, Translation, amMoment) {
        var k = 0;
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            $localStorage.translationsTable = {}; //$localStorage.translationsTable || {};
            //if the current translation changes, update the window title and other labels
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                var langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
                updateTitle();
                //change dates locale for momentJs
                amMoment.changeLocale(langKey);
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
